import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Solutions from "../pages/solutions/page";
import CustomAI from "../pages/custom-ai/page";
import DataAnalytics from "../pages/data-analytics/page";
import CustomSoftware from "../pages/custom-software/page";
import Integrations from "../pages/integrations/page";
import Automation from "../pages/automation/page";
import Industries from "../pages/industries/page";
import HowWeWork from "../pages/how-we-work/page";
import Security from "../pages/security/page";
import Insights from "../pages/insights/page";
import About from "../pages/about/page";
import SolutionsInPractice from "../pages/solutions-in-practice/page";
import ShapeYourProject from "../pages/shape-your-project/page";
import BookMeeting from "../pages/book-meeting/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/solutions",
    element: <Solutions />,
  },
  {
    path: "/custom-ai",
    element: <CustomAI />,
  },
  {
    path: "/data-analytics",
    element: <DataAnalytics />,
  },
  {
    path: "/custom-software",
    element: <CustomSoftware />,
  },
  {
    path: "/integrations",
    element: <Integrations />,
  },
  {
    path: "/automation",
    element: <Automation />,
  },
  {
    path: "/industries",
    element: <Industries />,
  },
  {
    path: "/how-we-work",
    element: <HowWeWork />,
  },
  {
    path: "/security",
    element: <Security />,
  },
  {
    path: "/insights",
    element: <Insights />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/solutions-in-practice",
    element: <SolutionsInPractice />,
  },
  {
    path: "/shape-your-project",
    element: <ShapeYourProject />,
  },
  {
    path: "/book-meeting",
    element: <BookMeeting />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;